import axios from "axios";

export const LOAD_TIMEOUT_MS = 20000;

const loadError = (code) => Object.assign(new Error(code), { code });

// Bound read-only page loads, including a connection lost while the request is
// in flight. Reject once, cancel the transport and discard any late response.
export const loadRequest = (request, timeoutMs = LOAD_TIMEOUT_MS) =>
  new Promise((resolve, reject) => {
    if (navigator.onLine === false) {
      reject(loadError("OFFLINE"));
      return;
    }
    const source = axios.CancelToken.source();
    let settled = false;
    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      window.removeEventListener("offline", offline);
      callback(value);
    };
    const interrupt = (code) => {
      finish(reject, loadError(code));
      source.cancel(code);
    };
    const offline = () => interrupt("OFFLINE");
    const timer = setTimeout(() => interrupt("LOAD_TIMEOUT"), timeoutMs);
    window.addEventListener("offline", offline);
    try {
      Promise.resolve(
        request({ timeout: timeoutMs, cancelToken: source.token })
      ).then(
        (value) => finish(resolve, value),
        (error) =>
          finish(
            reject,
            error?.code === "ECONNABORTED" ? loadError("LOAD_TIMEOUT") : error
          )
      );
    } catch (error) {
      finish(reject, error);
    }
  });
